export default __webpack_public_path__ + "static/media/trusted-by-disney.165bbd33.png";